import { API_BASE_ORIGIN } from "../config/api.js";
import { resolveEventLandscapeUrl, resolveEventPosterUrl } from "../api/events.js";

const SITE_NAME = (import.meta.env.VITE_SITE_NAME || "ShowTimeBro").trim();
const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://showtimebro.com").replace(/\/+$/, "");
const DEFAULT_OG = import.meta.env.VITE_OG_IMAGE || `${SITE_URL}/og-image.jpg`;

function isLocalOrigin(origin = "") {
  // Local-only hosts WhatsApp cannot crawl. Public tunnels (trycloudflare) are OK.
  return /localhost|127\.0\.0\.1|0\.0\.0\.0/i.test(String(origin));
}

function cleanOrigin(raw) {
  return String(raw || "")
    .trim()
    .replace(/\/+$/, "");
}

/** Canonical event page (what users open after click). */
export function getEventPageUrl(eventId) {
  if (!eventId) return SITE_URL;
  return `${SITE_URL}/events/${eventId}`;
}

/**
 * WhatsApp / social share URL — must be a public HTTPS page with OG tags.
 * Uses API /share/events/:id (returns event image). Humans are redirected
 * to showtimebro.com/events/:id.
 */
export function getEventShareUrl(eventId) {
  if (!eventId) return SITE_URL;

  const candidates = [
    cleanOrigin(import.meta.env.VITE_SHARE_ORIGIN),
    "https://api.showtimebro.com",
    cleanOrigin(API_BASE_ORIGIN),
  ].filter(Boolean);

  for (const origin of candidates) {
    if (!isLocalOrigin(origin)) {
      return `${origin}/share/events/${eventId}`;
    }
  }

  return getEventPageUrl(eventId);
}

/** WhatsApp click-to-chat with prefilled event link. */
export function getWhatsAppShareUrl(eventId, title) {
  const url = getEventShareUrl(eventId);
  const line = title ? `${title}\n${url}` : url;
  return `https://wa.me/?text=${encodeURIComponent(line)}`;
}

export function getEventShareImage(event) {
  return (
    resolveEventLandscapeUrl(event) ||
    resolveEventPosterUrl(event) ||
    DEFAULT_OG
  );
}

export function getEventShareDescription(event) {
  const raw = String(event?.description || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (raw) return raw.length > 180 ? `${raw.slice(0, 179).trim()}…` : raw;
  const venue = [event?.venue?.name, event?.venue?.city].filter(Boolean).join(", ");
  return [venue, event?.category].filter(Boolean).join(" · ") || `Book tickets on ${SITE_NAME}.`;
}

export { SITE_NAME, SITE_URL, DEFAULT_OG };
